import { useEffect, useState, useCallback, useRef } from "react";

// Hook simples de busca assíncrona com estados loading/error/data.
// Desacopla componentes da fonte de dados (mock hoje, API real depois).
export function useAsync(fn, deps = [], interval = 0) {
  const generation = useRef(0);
  const [version, setVersion] = useState(0);
  const [state, setState] = useState({ loading: true, error: null, data: null });

  const run = useCallback(() => {
    let active = true;
    const requestId = ++generation.current;
    setState((s) => ({ ...s, loading: true, error: null }));
    Promise.resolve()
      .then(fn)
      .then((data) => active && requestId === generation.current && setState({ loading: false, error: null, data }))
      .catch((error) => active && requestId === generation.current && setState({ loading: false, error, data: null }));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, version]);

  useEffect(() => run(), [run]);

  useEffect(() => {if (!interval) return; const timer=setInterval(()=>setVersion(v=>v+1),interval); return()=>clearInterval(timer);}, [interval]);
  return {...state, reload: () => setVersion(v=>v+1)};
}
